import {
  formatPhoneDisplay,
  formatPhoneHref,
} from '@airship-platform/common/validation';
import { FlexBox } from '@airship-platform/jam-web/components';
import { MailIcon, PhoneIcon, SmsIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ContactInfo } from '../../../../../data-access/appointments';

type ContactRowProps = {
  contact: ContactInfo;
};

const phoneTypeLabel: Record<'Phone' | 'MobilePhone', string> = {
  MobilePhone: 'Mobile',
  Phone: 'Landline',
};

const ContactRow: React.FC<ContactRowProps> = ({ contact }) => {
  const isMobile = contact.type === 'MobilePhone';
  const isPhone = isMobile || contact.type === 'Phone';
  const isEmail = contact.type === 'Email';

  const displayValue = isPhone
    ? formatPhoneDisplay(contact.value)
    : contact.value;

  const phoneHref = isPhone ? formatPhoneHref(contact.value) : '';

  return (
    <FlexBox
      alignItems={'center'}
      justifyContent={'space-between'}
      py={2}
      gap={2}
    >
      <FlexBox flexDirection={'column'} flex={1} minWidth={0} gap={0.5}>
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {displayValue}
        </Typography>
        {isPhone && (
          <Typography variant="body4" color={'textTertiary'}>
            {phoneTypeLabel[contact.type as 'Phone' | 'MobilePhone']}
          </Typography>
        )}
        {contact.memo && (
          <Typography variant="body4" color={'textTertiary'}>
            {contact.memo}
          </Typography>
        )}
      </FlexBox>
      <FlexBox
        flexDirection={['column', 'row']}
        justifyContent={'flex-end'}
        gap={1}
      >
        {isMobile && (
          <Button
            color="softGold"
            startIcon={<SmsIcon />}
            href={`sms:${phoneHref}`}
          >
            Text
          </Button>
        )}
        {isPhone && (
          <Button
            color="softGold"
            startIcon={<PhoneIcon />}
            href={`tel:${phoneHref}`}
          >
            Call
          </Button>
        )}
        {isEmail && (
          <Button
            color="softGold"
            startIcon={<MailIcon />}
            href={`mailto:${contact.value}`}
          >
            Email
          </Button>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default ContactRow;
